import i18next, { Resource } from "i18next";
import { initReactI18next } from "react-i18next";
import { languages } from "./i18n.constants";
import frTranslation from "@/i18n/locales/fr/translation.json";

const resources: Resource = {
  [languages.fr]: {
    translation: frTranslation,
  },
};

void i18next.use(initReactI18next).init({
  resources,
  lng: languages.fr,
});

export { i18next };
